module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-row",
    class: {
      error: _vm.error
    },
    style: (_vm.getStyle)
  }, [_c('label', [_vm._t("label"), _vm._v(" "), (_vm.required) ? _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]) : _vm._e()], 2), _vm._v(" "), _c('main', [_vm._t("input"), _vm._v(" "), (_vm.appendText) ? _c('span', {
    staticClass: "append-text"
  }, [_vm._v(_vm._s(_vm.appendText))]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error),
      expression: "error"
    }],
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.error))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b41307e2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/Form/BaseInput.vue
// module id = 3347
// module chunks = 0